<template>
  <div>
    <v-list-item
        class="px-0"
    >
      <v-container class="pa-0 pa-md-2">
        <v-skeleton-loader
            type="heading"
            class="mx-0"
        />
        <v-row>
          <v-col
              cols="12"
              md="4"
          >
            <v-skeleton-loader
                type="image"
            />
          </v-col>
          <v-col>
            <v-skeleton-loader
                type="paragraph, sentences"
            />
          </v-col>
        </v-row>
        <v-skeleton-loader
            type="chip@3"
        />
        <v-skeleton-loader
            type="divider"
        />
      </v-container>
    </v-list-item>
  </div>
</template>

<script>

export default{
  name: "CarRequestListItemSkeleton",
}
</script>

<style scoped>

</style>